import type { Prototype } from "../prototype-types";

export const ammadShaikhPrototypes: Prototype[] = [
  {
    id: "as-brand-promotions",
    name: "Brand Promotions",
    path: "/as/brand-promotions",
    description:
      "Brand Portal promotions hub, using the same production-like chrome as Brand Promo Orders.",
    project: "Brand Promotions",
    owner: "Ammad Shaikh",
    createdAt: "2026-09-28",
    lastUpdated: "2026-09-29",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/as-brand-promotions.png",
  },
  {
    id: "as-promo-in-header-under-total",
    name: "Promo in header + under total",
    path: "/as/promo-in-header-under-total",
    description:
      "Orders list with promo under total and order page with promo in header. Promo type is one step smaller than paragraph.",
    project: "Brand Promotions",
    owner: "Ammad Shaikh",
    createdAt: "2026-10-06",
    lastUpdated: "2026-10-06",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/as-promo-in-header-under-total.png",
  },
];
